import PropTypes from 'prop-types';
import React, { useRef } from 'react';
import ProductBox from '../BoxProduct/components/ProducBox';

const ProductCarousel = ({
    title,
    subtitle,
    products,
    openProductDetails,
    toggleProductFavorite,
    handleActionCarousel,
}) => {
    const containerRef = useRef(null);
    const scrollContainerRef = useRef(null);

    const scrollToDirection = (direction) => {
        if (!scrollContainerRef.current) return;

        const container = scrollContainerRef.current;
        const scrollAmount = container.offsetWidth * 0.8;

        if (direction === 'left') {
            container.scrollBy({
                left: -scrollAmount,
                behavior: 'smooth',
            });
        } else {
            container.scrollBy({
                left: scrollAmount,
                behavior: 'smooth',
            });
        }
    };

    const isScrollable = () => {
        if (!scrollContainerRef.current) return false;
        const container = scrollContainerRef.current;
        return container.scrollWidth > container.clientWidth;
    };

    if (!products || products.length === 0) {
        return null;
    }

    return (
        <div className="product-carousel">
            {(title || subtitle) && (
                <div className="product-carousel__header">
                    {title && (
                        <h3 className="product-carousel__title">{title}</h3>
                    )}
                    {subtitle && (
                        <p className="product-carousel__subtitle">{subtitle}</p>
                    )}
                </div>
            )}

            <div className="product-carousel__container" ref={containerRef}>
                <div className="product-carousel__navigation">
                    {isScrollable() && (
                        <button
                            className="product-carousel__arrow product-carousel__arrow--left"
                            onClick={() => scrollToDirection('left')}
                            aria-label="Scroll left"
                        >
                            <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M15.41 7.41L14 6L8 12L14 18L15.41 16.59L10.83 12L15.41 7.41Z"
                                    fill="currentColor"
                                />
                            </svg>
                        </button>
                    )}

                    <div className="product-carousel__cards-container">
                        <div
                            className="product-carousel__scroll-container"
                            ref={scrollContainerRef}
                        >
                            {products.map((product, index) => (
                                <div
                                    key={`${product.id}-${index}`}
                                    className="product-carousel__item"
                                >
                                    <ProductBox
                                        product={product}
                                        openProductDetails={openProductDetails}
                                        toggleProductFavorite={
                                            toggleProductFavorite
                                        }
                                        isCartPage={true}
                                        handleActionCarousel={
                                            handleActionCarousel
                                        }
                                    />
                                </div>
                            ))}
                        </div>
                    </div>

                    {isScrollable() && (
                        <button
                            className="product-carousel__arrow product-carousel__arrow--right"
                            onClick={() => scrollToDirection('right')}
                            aria-label="Scroll right"
                        >
                            <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M8.59 16.59L10 18L16 12L10 6L8.59 7.41L13.17 12L8.59 16.59Z"
                                    fill="currentColor"
                                />
                            </svg>
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

ProductCarousel.propTypes = {
    title: PropTypes.string,
    subtitle: PropTypes.string,
    products: PropTypes.array.isRequired,
    openProductDetails: PropTypes.func.isRequired,
    toggleProductFavorite: PropTypes.func.isRequired,
};

export default ProductCarousel;
